import { Candidate } from './Model/Candidate';
import { JobCenterModelInterface, ReferenceId } from './Model/JobCenterModelInterface';
import { JobVacancy } from './Model/JobVacancy';

export interface ReferenceIdContainerInterface {
    length: number

    identifiers: ReferenceId[]

    contains(referenceId: ReferenceId): boolean

    contains(model: JobCenterModelInterface): boolean

    withAdded(referenceId: ReferenceId): ReferenceIdContainer

    withRemoved(referenceId: ReferenceId): ReferenceIdContainer
}

export class ReferenceIdContainer implements ReferenceIdContainerInterface {
    private ids: ReferenceId[];

    constructor(ids: ReferenceId[]) {
        this.ids = ids;
    }

    get length(): number {
        return this.ids.length;
    }

    get identifiers(): ReferenceId[] {
        return this.ids;
    }

    public contains(referenceIdOrModel: ReferenceId | JobCenterModelInterface): boolean {
        if (this.isModel(referenceIdOrModel)) {
            return this.indexOf(referenceIdOrModel.referenceId) >= 0;
        } else if (referenceIdOrModel !== undefined && referenceIdOrModel !== null) {
            return this.indexOf('' + referenceIdOrModel) >= 0;
        } else {
            throw new TypeError('Invalid type given');
        }
    }

    private isModel(referenceIdOrModel: string | JobCenterModelInterface): referenceIdOrModel is JobCenterModelInterface {
        return referenceIdOrModel instanceof Candidate || referenceIdOrModel instanceof JobVacancy || (typeof referenceIdOrModel == 'object' && typeof referenceIdOrModel.referenceId !== 'undefined');
    }

    public withAdded(referenceId: ReferenceId): ReferenceIdContainer {
        const clone = this.clone();
        if (!this.contains(referenceId)) {
            clone.ids.push(referenceId);
        }
        return clone;
    }

    public withRemoved(referenceId: ReferenceId): ReferenceIdContainer {
        const clone = this.clone();
        const position = this.indexOf(referenceId);
        if (position < 0) {
            return clone;
        }
        clone.ids.splice(position, 1);

        return clone;
    }

    private indexOf(referenceId: string) {
        return this.ids.indexOf(referenceId);
    }

    public clone(): ReferenceIdContainer {
        return new ReferenceIdContainer(this.ids.slice());
    }

}
